module.exports = __webpack_public_path__ + "media/blog_onboarding_account_screen.7ebf42b6.mp4";